import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LessonExternalLinks = ({ externalLinks = [] }) => {
  // Função para obter ícone baseado na plataforma
  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'youtube':
        return 'Youtube';
      case 'instagram':
        return 'Instagram';
      case 'linkedin':
        return 'Linkedin';
      case 'facebook':
        return 'Facebook';
      case 'twitter':
        return 'Twitter';
      case 'website':
      default:
        return 'ExternalLink';
    }
  };

  // Função para obter cor baseada na plataforma
  const getPlatformColor = (platform) => {
    switch (platform) {
      case 'youtube':
        return 'text-red-500';
      case 'instagram':
        return 'text-pink-500';
      case 'linkedin':
        return 'text-blue-600';
      case 'facebook':
        return 'text-blue-500';
      case 'twitter':
        return 'text-sky-500';
      case 'website':
      default:
        return 'text-gray-500';
    }
  };

  // Função para obter nome da plataforma
  const getPlatformName = (platform) => {
    switch (platform) {
      case 'youtube':
        return 'YouTube';
      case 'instagram':
        return 'Instagram';
      case 'linkedin':
        return 'LinkedIn';
      case 'facebook':
        return 'Facebook';
      case 'twitter':
        return 'Twitter';
      case 'website':
      default:
        return 'Site';
    }
  };

  // Se não há links, mostrar estado vazio
  if (!externalLinks || externalLinks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 px-6 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon name="Video" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">
          Nenhum vídeo relacionado
        </h3>
        <p className="text-sm text-muted-foreground">
          Não há outros vídeos disponíveis neste momento.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {externalLinks.map((link) => {
        const platformName = getPlatformName(link.platform);
        const linkUrl = link.library_url || link.original_url;

        return (
          <div
            key={link.id}
            className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-micro"
          >
            <div className="flex items-center space-x-3 flex-1 min-w-0">
              <div className={`flex-shrink-0 ${getPlatformColor(link.platform)}`}>
                <Icon 
                  name={getPlatformIcon(link.platform)} 
                  size={20} 
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">
                  {link.title}
                </p>
                <p className="text-xs text-muted-foreground">
                  {platformName}
                </p>
                {link.config?.description && (
                  <p className="text-xs text-muted-foreground truncate">
                    {link.config.description}
                  </p>
                )}
              </div>
            </div>

            <Button
              variant="outline"
              size="sm"
              iconName="ExternalLink"
              iconPosition="left"
              iconSize={14}
              onClick={() => {
                if (linkUrl) {
                  window.open(linkUrl, '_blank', 'noopener,noreferrer');
                }
              }}
              className="flex-shrink-0"
            >
              Acessar
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default LessonExternalLinks;
